/**
 * Test to improve image loading and product image accuracy on sign-up modal.
 * It replaces requests to /api/seo/sign-up-modal/ and /api/product/productToken/best-image/
 * with product tile data already loaded on the current page.
 */
export const SIGN_UP_MODAL_IMAGE_FROM_PAGE_RESULTS_2024_NOV = 'SIGN_UP_MODAL_IMAGE_FROM_PAGE_RESULTS_2024_NOV';
